import { ActionReducerMapBuilder, createAsyncThunk } from '@reduxjs/toolkit'
import Container from 'typedi'
import i18n from 'i18n'

import { ApplicationState } from '@/state/root.models'
import { RestApiService } from '@/services'
import {
  setLoadingFullAction,
  setSnackbarAction,
} from '@/state/ui/global/slices/index.slices'

import { jsonToQueryString } from '@/utils'
import ActionTypes from '../constants'
import {
  ContributionsFreePlaysPayload,
  ContributionsFreePlaysResponse,
  TransactionState,
} from '../models'

import { TRANSACTIONS } from './api.routes'
import { TransactionsActions } from '../slices/index.slices'

const restApiService: RestApiService = Container.get(RestApiService)

export const getAllFreePlayContributionsThunk = createAsyncThunk(
  ActionTypes.GET_ALL_FREEPLAY_CONTRIBUTIONS,
  async (payload: ContributionsFreePlaysPayload, thunkAPI) => {
    try {
      const { xlsx, ...queries } = payload
      const { auth } = thunkAPI.getState() as ApplicationState

      if (!xlsx) {
        thunkAPI.dispatch(TransactionsActions.setIsloadingAction(true))
      }

      thunkAPI.dispatch(setLoadingFullAction(true))

      restApiService.requestParams = {
        method: 'GET',
        endpoint: TRANSACTIONS.FREE_PLAY_CONTRIBUTIONS,
        queries: jsonToQueryString(queries),
      }

      const response: ContributionsFreePlaysResponse =
        await restApiService.getData(auth.brand.siteId.toString(), auth.token)

      thunkAPI.dispatch(setLoadingFullAction(false))

      if (response.status && response.status !== 200) {
        const message =
          typeof response.message === 'string'
            ? response.message
            : i18n.t('messages.errorOccurred')

        thunkAPI.dispatch(
          setSnackbarAction({
            message,
            open: true,
            variant:
              response?.status && response?.status !== 200
                ? 'error'
                : 'success',
          }),
        )
      }

      return response
    } catch (error) {
      thunkAPI.dispatch(setLoadingFullAction(false))
      return thunkAPI.rejectWithValue({
        message: error,
        status: error,
      })
    }
  },
)

const getAllFreePlayContributionsExtraReducer = (
  builder: ActionReducerMapBuilder<TransactionState>,
) => {
  builder.addCase(
    getAllFreePlayContributionsThunk.fulfilled,
    (state, { payload, meta }) => {
      const { xlsx } = meta?.arg

      state.isLoading = false
      state.contributions = xlsx ? state.contributions : payload.docs
      state.pagination = xlsx
        ? state.pagination
        : {
            ...state.pagination,
            total: payload.total,
            pages: payload.pages,
            page: payload.page,
            limit: payload.limit,
          }
    },
  )
  builder.addCase(getAllFreePlayContributionsThunk.rejected, (state) => {
    state.isLoading = false
  })
}

export default getAllFreePlayContributionsExtraReducer
